import React, { useEffect, useState } from 'react';
import { SingleCollapse, MasterDataGrid } from "@/components/";
import FollowupSubProjectPresenter from "../../../../../presenters/screens/followup-subproject.presenter";
import { IFollowupSubproject } from "@interfaces/screens/followup-subproject.interface";
import styles from './index.module.scss';
import BeneficiariesError from '../beneficiaries-error';
import { Enums } from "@utils";
interface IExpectedResults{
    result: any;
    screen?: string;
	index: any;
	columns: any;
	dataColumns: any;
	projectData: any;
	tableAlert: string;
	status: any;
	saveTable(instance: any): void;
}

const ExpectedResults: React.FC<IExpectedResults> = ({result, index, screen, tableAlert, columns, dataColumns, status, saveTable}: IExpectedResults) => {
	const [auxData, setAuxData] = useState(null);

	const view: IFollowupSubproject = {
        state: {
			dataColumns
        },
    };

	const presenter = new FollowupSubProjectPresenter(view);

	useEffect(() => {
        if((tableAlert === `${result.id}-expected-result-beneficiaries` || !tableAlert || tableAlert === 'All') && result && columns) {
			if(presenter.stepTourBen > 1 && index === 0){
                let dataTour = presenter.getTourData(5, Enums.FollowupDimensions.beneficiaries)
                let asd = getAuxData(dataTour)
                setAuxData(asd)
            }else{
                let asd = getAuxData()
                setAuxData(asd)
            }
        }
    }, [result.data, tableAlert, columns, presenter.stepTourBen]); 

	const getAuxData = (tourData?: any) => {
		return (
            <>
				<BeneficiariesError 
					followupLabels={presenter.followupLabels}
					tableAlert={tableAlert}
					gridId={`${result.id}-expected-result-beneficiaries`} 
					calculatedReqFields={(item: any) => presenter.checkReqFields(item, status)} 
					calculatedBenPlan={(item: any) => presenter.checkBenPlan(item, status?.CodigoDimension)} 
					calculatedBenTotals={(table: any) => presenter.checkBenTotals(table, status?.CodigoDimension)} 
					changeStyles={changeStyles}
				/>
				<MasterDataGrid 
					id={`${result.id}-expected-result-beneficiaries`}
					dataSource={tourData || result.data}
					columns={columns?.activity}
					key={"id"}
					allowCode={screen}
					gridTitle={presenter.followupLabels.get("beneficiariesByExpectedResultTitle")}
					gridHelpId={`tooltip-expected-result-beneficiaries-${result.id}`}
					gridHelpText={presenter.followupLabels.get("helpBeneficiariesByExpectedResult")}
					saveTable={saveTable}
					gridProps={{
						editing:{ mode:"batch", allowUpdating:true, allowAdding: false, allowDeleting: false},
						rowAlternationEnabled:false,
					}} 
				/>
            </>
        )
    }

	const changeStyles = (parentGrid: any) => {
        if(parentGrid !== undefined){
			const row = parentGrid.getRowElement(parentGrid.getVisibleRows().length - 3);
			const row2 = parentGrid.getRowElement(parentGrid.getVisibleRows().length -2);
			const row3 = parentGrid.getRowElement(parentGrid.getVisibleRows().length -1);

			if(parentGrid.getVisibleRows().length > 3){
				if(row !== undefined) row[0].classList.add(styles.subTotal);
				if(row2 !== undefined) row2[0].classList.add(styles.subTotaledit);
				if(row3 !== undefined) row3[0].classList.add(styles.subTotal);
			}else{
				if(row2 !== undefined) row2[0].classList.add(styles.subTotal);
				if(row3 !== undefined) row3[0].classList.add(styles.subTotal);
			}
		}
    }

	return (
		<SingleCollapse 
			keepOpen={!!tableAlert}
			title={result.staticTitle} 
			description={result.name}
			isOpen={(tableAlert === "All") ? true : index === 0}
			key={index}
			idIcon={index === 0 ? 'BeneficiariesTourStep5' : ''}
		>
            {auxData && auxData}
		</SingleCollapse>
	)
}
export default ExpectedResults;
